import React, { Component } from 'react';
import EmbedHeaderComponent from './_EmbedHeaderComponent';
import ResultComponent from './_ResultComponent';
import HotWrapper from './_HotWrapper';

const styles = {
  containerStyle: {
    height: '280px',
    // width: '100%',
    marginTop: '42px',
    borderBottomLeftRadius: '5px',
    borderBottomRightRadius: '5px',
    border: '1px solid grey',
    borderTop: '0',
    overflow: 'auto',
  }
}

class _EnvelopeContainer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      active: "", // activeTab
      tableState: [[]],
      resultSize: {
        width: 0,
        height: 0
      }
    }
    this.hotData =  [[]]
  }
  componentWillReceiveProps(nextProps) {
    this.hotData = nextProps.envelope ? nextProps.envelope.table : [[]];
    console.log('REC PROPS', nextProps, this.state.active);
    if (nextProps.data === "on" && this.state.active !== "data") {
      this.setState({ active: "data" })
    } else {
      this.setState({ active: '' })
    }
  }
  onButtonClick = (buttonName) => {
    this.setState({
      active: this.state.active === buttonName ? "" : buttonName
    })
  }
  onHotChange = (data, changes, source) => {
    this.setState({ tableState: this.hotData })
  }
  render() {
    const { containerStyle } = JSON.parse(JSON.stringify(styles));
    containerStyle.height = this.props.window.height - 42 + 'px';

    return (
      <div>
        <EmbedHeaderComponent
          mobile={this.props.mobile}
          active={this.state.active}
          buttonClick={this.onButtonClick}
          navigateToEditPage={this.props.navigateToEditPage}
        />
        <div style={containerStyle}>
          <HotWrapper
            window={this.props.window}
            width={this.state.active === "data" ? 25 : 0}
            hotData={this.hotData}
            onHotChange={this.onHotChange}
            active={this.state.active}
          />
          <ResultComponent
            width={this.state.active === "data" ? 75 : 100}
            parentSize={this.state.resultSize}
            envelope={this.props.data === 'on' ?
              this._mergeEvData(this.props.envelope, this.state.tableState) :
              this.props.envelope}
          />
        </div>
      </div>
    );
  }
  _mergeEvData = (envelope, data) => {
    if (envelope === null) return null;
    var newEnvelope = JSON.parse(JSON.stringify(envelope));
    newEnvelope.table = data;
    return newEnvelope;
  }
}

export default _EnvelopeContainer;



// WEBPACK FOOTER //
// ./src/_EnvelopeContainer.js